module.exports = {
  realm: 'FR',
  market: 'fr-FR',
  domain: 'weightwatchers.fr',
  countryId: '4000',
  vsPath: 'fr',
  spiceLocale: 'fr',
  vsUrl: 'https://www{env}weightwatchers.com/fr',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/fr/messages/',
  cmxSiteUrl: 'https://cmx{env}weightwatchers.fr/',
  currency: '€',
  decimalSeparator: ',',
  thousandSeparator: ' ',
  currencyFormat: '%number €',
  dateFormat: 'dd/MM/yyyy',
  loginApiUrl: 'https://auth{env}weightwatchers.fr/login-apis/',
  loginWebUrl: 'https://auth{env}weightwatchers.fr/v2/login/',
  countryCode: 'FR',
  commUlr: 'https://commerce{env}weightwatchers.com/fr/fr/api/',
  timezone1: 'Europe/Paris',
  timezone2: '+01:00',
};
